import { Component, Inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
    selector: 'app-collegedetails',
    templateUrl: './collegedetails.component.html',
    styleUrls: ['./collegedetails.component.scss'],
    imports: [CommonModule,MatDialogModule,MatButtonModule, TranslateDirective],
    standalone: true
})
export class CollegedetailsComponent implements OnInit {

  SubOrgData:any;

  constructor(
     private dialogRef: MatDialogRef<CollegedetailsComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  
  ngOnInit(): void {
    this.SubOrgData=this.data.data;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
